/* prettier-ignore */
export const content = {
  'designer.components.finder.add-component-action': 'Add component',
  'designer.components.finder.component-name-suffix': '(component)',
  'designer.components.finder.tab-name': 'Components',
  'designer.components.manager.components-title': 'Components',
  'designer.components.manager.create-from-blank': 'Create blank',
  'designer.components.manager.create-from-element': 'Convert selection',
  'designer.components.manager.create-new-component':
    'Create component {{command}}',
  'designer.components.manager.disabled-tooltip':
    'Select an element to create component',
  'designer.components.manager.disabled-tooltip-multi-select': 'Select 1 element to create a component',
  'designer.components.manager.create-component.cancel-action': 'Cancel',
  'designer.components.manager.create-component.create-action': 'Create',
  'designer.components.manager.create-component.input-placeholder': 'Name',
  'designer.components.manager.create-component.group-autocomplete': 'Group',
  'designer.components.manager.component-desc': 'Description',
  'designer.components.manager.create-component.title': 'Create component',
  'designer.components.manager.create-component.suggested-props.label': 'Create {{count}} {{propertyPluralized}}',
  'designer.components.manager.create-component.suggested-props.tooltip': 'Selected properties will be created and connected automatically',
  'designer.components.manager.create-component.unsupported-props.label': 'Disconnects {{count}} CMS {{fieldPluralized}}',
  'designer.components.manager.edit-component.input-placeholder': 'Name',
  'designer.components.manager.edit-component.prevent-component-deletion':
    "Can't delete components with active instances",
  'designer.components.manager.edit-component.prevent-component-save':
    'Component with this name already exists',
  'designer.components.manager.edit-component.description-too-long-error':
    'Component description must be fewer than 256 characters',
  'designer.components.manager.edit-component.title': 'Component settings',
  'designer.components.manager.edit-component.show-for-marketers-label': 'Show for Marketers',
  'designer.components.manager.edit-component.show-for-marketers-tooltip': 'Marketers can find this component in the Add panel. Uncheck to keep it Designer-only.',
  'designer.components.manager.view-component-instances.title':
    'In other components',
  'designer.components.manager.view-component-instances.this-page-title':
    'On this page',
  'designer.components.manager.view-component-instances.in-this-component-title':
    'In this component',
  'designer.components.manager.view-component-instances.other-pages-title':
    'Other pages with instances',
  'designer.components.manager.view-component-instances.other-components-title':
    'Instances in other components',
  'designer.components.manager.duplicate-component.title':
    'Duplicate component',
  'designer.components.manager.empty-state.no-components-title':
    'No components created yet',
  'designer.components.manager.empty-state.components-description':
    'Components let you reuse designs in your site. To create a component, right-click an element on the canvas and select “Create component”.',
  'designer.components.manager.empty-state.components-shortcut':
    'Create component shortcut: <strong>{{shortcutText}}</strong>',
  'designer.components.manager.icon-tooltip': 'Components ({{command}})',
  'designer.components.manager.icon-tooltip-disabled':
    'The Components panel is disabled {{reason}}.',
  'designer.components.manager.search-components': 'Search components',
  'designer.components.outline-breadcrumbs.edit-component': 'Edit component',
  'designer.components.settings.properties.title': 'Component properties',
  'designer.components.settings.properties.reset': 'Reset all properties',
  'designer.components.settings.binding-button.cta': 'Connect to property',
  'designer.components.settings.binding-button.disabled-tooltip':
    'The element is already connected to a Collection field.',
  'designer.components.settings.properties.section-header':
    'Component properties',
  'designer.components.settings.properties.manage-properties':
    'Manage Properties',
  'designer.components.settings.properties.properties': 'Properties',
  'designer.components.settings.properties.suggested-props.title': 'Suggested properties',
  'designer.components.settings.properties.suggested-props.main-checkbox': 'All properties',
  'designer.components.settings.properties.custom-components-read-only-note.title': 'Code components disabled',
  'designer.components.settings.properties.custom-components-read-only-note.body': 'Code components are automatically disabled in read-only mode.',
  'designer.components.settings.properties.custom-components-error-note.title': 'Code component crashed',
  'designer.components.settings.properties.custom-components-error-note.body': 'View the error in your browser console.',
  'designer.components.settings.properties.custom-components-error-note.action': 'Reload',
  'designer.components.settings.properties.custom-components-safe-mode-note.title': 'Code components disabled',
  'designer.components.settings.properties.custom-components-safe-mode-note.body': 'Code components are automatically disabled on the canvas after {{reason}}. Components can still be previewed and will continue to work on published sites.',
  'designer.components.settings.properties.custom-components-safe-mode-note.body.transfer': 'a site transfer',
  'designer.components.settings.properties.custom-components-safe-mode-note.body.crash': 'a crash',
  'designer.components.settings.properties.custom-components-safe-mode-note.action': 'Enable code components',
  'designer.components.settings.properties.vibe-component-ai-note.title': 'Customize props with AI',
  'designer.components.settings.properties.vibe-component-ai-note.body': 'Use the AI Assistant to add or change properties.',
  'designer.components.settings.properties.vibe-component-ai-note.action': 'Ask AI Assistant',
  'designer.components.navigator.vibe-component-structure-note.body': 'Use the AI Assistant to modify component structure.',
  'designer.components.navigator.vibe-component-structure-note.action': 'Ask AI Assistant',
  'designer.components.settings.properties.suggested-props.review-button': 'Review',
  'designer.components.settings.properties.suggested-props.banner': '{{amount}} suggested {{propPluralized}}',
  'designer.components.settings.properties.suggested-props.cancel-button': 'Cancel',
  'designer.components.settings.properties.suggested-props.create-button': 'Create',
  'designer.components.settings.properties.suggested-props.dismiss-all-button': 'Dismiss all',
  'designer.components.settings.properties.suggested-props.rename-error.duplicate-name':
    'Prop name already exists',
  'designer.components.settings.properties.suggested-props.rename-error.empty-prop-name':
    'Prop name cannot be empty',
  'designer.components.settings.properties.disconnected-property':
    '(disconnected)',
  'designer.components.settings.properties.disabled-tooltip':
    'This content cannot be edited globally. Go back to the page to make edits to that instance.',
  'designer.components.mini-toolbar.editing-disabled-tooltip':
    'This cannot be edited.',
  'designer.components.mini-toolbar.auto-sync-editing-disabled-tooltip':
    'Managed by continuous translation. Switch to one-time translation to edit.',
  'designer.components.settings.properties.add-property-tooltip':
    'Add property',
  'designer.components.settings.properties.empty-state.heading':
    'No properties yet',
  'designer.components.settings.properties.empty-state.description':
    'Create a property and connect it to an element by clicking the + or the purple dots.',
  'designer.components.settings.properties.empty-state.description-new':
    'Create a property and connect it to an element to enable instance customization',
  'designer.components.settings.properties.empty-state.description-left-panel':
    'Create properties to enable instance customization',
  'designer.components.settings.properties.empty-state.localization.description':
    'Switch to the primary locale to create and manage properties.',
  'designer.components.settings.properties.empty-state.branch-restricted.heading':
    "Can't edit on a branch",
  'designer.components.settings.properties.empty-state.branch-restricted.description':
    "To edit component instance properties in a rich text field you can't be on a branch.",
  'designer.components.settings.properties.new-property.title':
    'New component property',
  'designer.components.settings.properties.new-property.description':
    'This property will be connected to the selected element',
  'designer.components.settings.properties.new-property.create-cta':
    'Create property',
  'designer.components.settings.properties.delete-property.title':
    'Delete property?',
  'designer.components.settings.properties.delete-property.reference':
    'setting',
  'designer.components.settings.properties.delete-property.element': 'element',
  'designer.components.settings.properties.delete-property.elements':
    'elements',
  'designer.components.settings.properties.delete-property.description':
    'Deleting the property will disconnect it from {{amount}} {{reference}}',
  'designer.components.settings.properties.delete-property.component-instances':
    'This property will be permanently deleted and removed from {{amount}} component {{reference}}.',
  'designer.components.settings.properties.delete-property.instance':
    'instance',
  'designer.components.settings.properties.delete-property.instances':
    'instances',
  'designer.components.settings.properties.delete-property.component-variants':
    '{{amount}} {{reference}} will be deleted. All component instances will be set to the base variant.',
  'designer.components.settings.properties.delete-property.variant': 'variant',
  'designer.components.settings.properties.delete-property.variants':
    'variants',
  'designer.components.settings.properties.delete-property.new-description':
    'This property will be disconnected from {{amount}} {{reference}}:',
  'designer.components.settings.properties.delete-property.delete-cta':
    'Delete',
  'designer.components.settings.properties.delete-property.cancel-cta':
    'Cancel',
  'designer.components.settings.properties.optimization-blocker.allowed.body':
    'Edited instances ignore changes to property values on the base instance',
  'designer.components.settings.optimization-blocker.allowed.edit-in-variation-cta':
    'Edit in variation',
  'designer.components.settings.properties.optimization-blocker.allowed.edit-in-variation-cta':
    'Edit properties in variation',
  'designer.components.settings.optimization-blocker.forbidden-locale.title':
    'No variation content to localize',
  'designer.components.settings.optimization-blocker.forbidden-locale.body':
    'Make a change in the primary locale first',
  'designer.components.settings.optimization-blocker.forbidden-element.title':
    "You can't change these settings",
  'designer.components.settings.optimization-blocker.forbidden-element.body':
    "This content and settings can't be changed in a variation. Try editing other elements instead.",
  'designer.components.settings.optimization-blocker.forbidden-code-block-embed.body':
    "This content and settings can't be changed in a variation.",
  'designer.components.settings.optimization-blocker.forbidden-multi-experience.title':
    'Optimization not allowed',
  'designer.components.settings.optimization-blocker.forbidden-multi-experience.body':
    'This element changed in another optimization.',
  'designer.components.settings.optimization-blocker.multi-experience.view-label': 'Current optimization',
  'designer.components.settings.optimization-blocker.multi-experience.live-body': 'You can’t edit this element’s settings until you archive the existing optimization',
  'designer.components.settings.optimization-blocker.multi-experience.not-live-body': 'You can’t edit this element’s settings until you archive the existing optimization',
  'designer.components.settings.optimization-blocker.multi-experience.deletable-body': 'You can’t edit this element’s settings until you delete the existing optimization',
  'designer.components.settings.optimization-blocker.multi-experience.status-live': 'Live',
  'designer.components.settings.optimization-blocker.multi-experience.status-archived': 'Archived',
  'designer.components.settings.optimization-blocker.multi-experience.status-draft': 'Draft',
  'designer.components.settings.optimization-blocker.multi-experience.status-approving': 'Ready',
  'designer.components.settings.optimization-blocker.multi-experience.status-not-live': 'Off',
  'designer.components.settings.optimization-blocker.multi-experience.not-live-cta': 'Archive',
  'designer.components.settings.optimization-blocker.multi-experience.deletable-cta': 'Delete',
  'designer.components.settings.optimization-blocker.multi-experience.live-cta': 'View optimization',
  'designer.components.settings.optimization-blocker.multi-experience.modal-cancel': 'Review optimization',
  'designer.components.settings.optimization-blocker.multi-experience.note-delete': 'Learn more about deleting',
  'designer.components.settings.optimization-blocker.multi-experience.note-archive': 'Learn more about archiving',
  'designer.components.settings.optimization-interactions-blocker.title':
    'Interaction editing unavailable',
  'designer.components.settings.optimization-interactions-blocker.body':
    "Editing interactions within variations isn't currently supported. To modify interactions, please make changes to your base site.",
  'designer.components.settings.optimization-style-blocker.forbidden-locale.title':
    'Style editing restricted',
  'designer.components.settings.optimization-style-blocker.forbidden-locale.body':
    "Styles can't be changed in variations when in a secondary locale.",
  'designer.components.settings.optimization-style-blocker.no-rule.title':
    'Style editing restricted',
  'designer.components.settings.optimization-style-blocker.no-rule.body':
    'Add a class in the base site before changing styles in variations.',
  'designer.components.settings.properties.optimization-blocker.learn-more':
    'Learn more',
  'designer.components.ftu.popover.components-description':
    'Reuse elements like navbars on multiple pages, by creating components.',
  'designer.components.ftu.popover.props-panel-title': 'Properties panel',
  'designer.components.ftu.popover.props-panel-description':
    'Manage props from the new Properties panel when editing a main component.',
  'designer.components.ftu.popover.manage-components':
    'Manage reusable components in green from Components.',
  'designer.components.ftu.notifications.component-added.title':
    'Experience the power of components',
  'designer.components.ftu.notifications.component-added.description':
    'Components let you reuse designs across your site. Changes in the main component will affect all instances. To customize an instance, add properties to your component.',
  'designer.components.ftu.notifications.component-added.learn-more-cta':
    'Learn more about components',
  'designer.components.ftu.notification.property-created.title': `You've just created and connected a property`,
  'designer.components.ftu.notification.property-created.description': `Properties let you edit component instances' content without affecting other instances. Now you can modify the element's value.`,
  'designer.components.ftu.notification.property-created.go-to-component-cta':
    'Go to component instance',
  'designer.components.ftu.note.title': 'Create reusable components',
  'designer.components.ftu.note.description': `Properties let you edit component instances' content without affecting other instances.`,
  'designer.components.ftu.properties-guidance-note.description':
    'Now you can modify properties independently in different instances of this component.',
  'designer.components.ftu.properties-guidance-note.cta':
    'Go to component instance',
  'designer.components.ftu.properties-binding-dot.suffix':
    'to connect this element to a property.',
  'designer.components.settings.dynamo.disabled-by-symbol':
    'This is disabled as the element is already connected to a component property',
  'designer.components.settings.properties.manage': 'Manage all properties...',
  'designer.components.settings.properties.disconnect': 'Disconnect',
  'designer.components.settings.properties.new':
    'New {{propertyType}} property',
  'designer.components.settings.properties.new-conditional':
    'Create conditional',
  'designer.components.settings.properties': 'Select connected property:',
  'designer.components.settings.properties.connect-data': 'Connect',
  'designer.components.settings.properties.edit-settings': 'Edit settings',
  'designer.components.settings.manage-properties.unlinked-note':
    "This property isn't connected to any of the component’s elements. Connect the property to an element to be able to modify it on each instance.",
  'designer.components.settings.connected-to-elements.single':
    'Connected to {{count}} element',
  'designer.components.settings.connected-to-elements.multiple':
    'Connected to {{count}} elements',
  'designer.components.settings.unlinked-field-settings':
    'This property isn’t connected to any of the component’s elements. Connect the property to an element to be able to modify it on each instance.',
  'designer.components.settings.create-field.default-text-value':
    'This is the default text value',
  'designer.components.settings.create-field.default-rich-text-value':
    'This is the default rich text value',
  'designer.components.props.warning-icon-tooltip-top-text':
    "Unlinked properties aren't connected to any of the component's elements.",
  'designer.components.props.warning-icon-tooltip-bottom-text':
    'Connect the property to an element to be able to modify it on each instance.',
  'designer.components.props.devlink-slot-deprecated-tooltip':
    'DevLink slots are deprecated. You can convert these to component slots or delete them.',
  'designer.components.props.devlink-slot.convert-button': 'Convert',
  'designer.components.props.devlink-slot.delete-button': 'Delete',
  'designer.components.props.devlink-slot.deprecated-badge': 'Deprecated',
  'designer.components.context-menu.edit-in-context': 'Edit component',
  'designer.components.context-menu.edit-in-context_component-canvas': 'Edit component',
  'designer.components.context-menu.create': 'Create component',
  'designer.components.slot.unlink-instance-tooltip': 'Cannot unlink component instances inside a Slot',
  'designer.components.rich-text.unlink-instance-disabled': 'Cannot unlink component instances inside Rich Text',
  'designer.components.rich-text.edit-instance-disabled': 'Cannot edit main components inside Rich Text',
  'designer.components.optimization.unlink-instance-tooltip': 'Cannot unlink component instances in optimize mode',
  'designer.components.context-menu.show-instances': 'Show instances',
  'designer.components.drag-overlay.moving': 'Moving entire component',
  'designer.components.style-manager.affected-components':
    'Components affected',
  'designer.components.style-manager.tag-styles-priorities':
    'Tag styles higher in this list take priority over styles below. Styles you set on this site override tag styles from libraries.',
  'designer.components.style-manager.manage-tag-styles':
    'Manage library tag styles',
  'designer.components.style-manager.manage-tag-styles-on-branch':
    "Tag styles can't be modified on a branch.",
  'designer.components.style-manager.tag-styles-active': 'Active',
  'designer.components.style-manager.tag-styles-inactive': 'Inactive',
  'designer.components.style-manager.tag-styles-reorder':
    'Reorder {{libraryName}}',
  'designer.components.cms.components-heading': 'Components',
  'designer.components.cms.component-property': 'Component property',
  'designer.components.settings.not-connected-note':
    'This property is not connected to an element in the component.',
  'designer.components.disabled-tooltip.with-permission': 'edit this component',
  'designer.components.disabled-tooltip.no-permission':
    'Cannot edit the main component',
  'designer.components.permissions.roles.no-permission':
    "Your role doesn't have permission to edit this component",
  'designer.components.permissions.roles.with-permission.create':
    'create components',
  'designer.components.permissions.roles.no-permission.create':
    "Components can't be created",
  'designer.components.settings.mismatch-type':
    'This value won’t be applied because the property type has been changed to “{{expectedType}}”. This is not compatible with the “{{receivedType}}” value applied here.',
  'designer.components.audit-log-item': 'Component',
  'designer.components.disabled-card.link-prefix':
    'To change {{settingsType}},',
  'designer.components.disabled-card.link-text': 'edit the component.',
  'designer.components.disabled-card.edit-component-shortcut':
    'Edit component shortcut: <strong>{{shortcutText}}</strong>',
  'designer.components.use-create-component.disabled-message.no-element-selected':
    'To create a component, select an element on the canvas',
  'designer.components.use-create-component.disabled-message.selected-element-incompatible':
    "The selected element can't be turned into a component.",
  'designer.components.entry-point.create-component.title': 'Create component',
  'designer.components.entry-point.edit-component.title': 'Edit component',
  'designer.components.entry-point.edit-component.description':
    'Changes made in {{componentName}} will affect all instances of {{componentName}}',
  'designer.component-canvas.entry-point.banner.body': 'Changing this component will modify {{count}} {{instancePluralized}}.',
  'designer.component-canvas.entry-point.banner.body-page-branch': 'Changing this component will modify {{count}} {{instancePluralized}} on this branch.',
  'designer.component-canvas.entry-point.banner.body-cms':
    'Used in {{count}} {{instancePluralized}}, with every field managed in one place.',
  'designer.component-editing.banner.back-to-page': 'Back to page',
  'designer.component-editing.banner.edit-in-cms': 'Edit in CMS',
  'designer.components.settings.properties.empty-state.property-instructions-cta':
    'Edit the component',
  'designer.components.settings.properties.empty-state.property-instructions-link-text':
    'Edit component',
  'designer.components.settings.properties.empty-state.property-instructions':
    'to create or manage properties',
  'designer.components.settings.properties.empty-state.learn-more':
    'Learn more about properties',
  'designer.components.settings.properties.empty-state.learn-more-left-panel':
    'Learn more',
  'designer.components.style-variants.popover.title': 'Component variants',
  'designer.components.style-variants.empty-state':
    'Add variants to provide different styles to select from on component instances.',
  'designer.components.style-variants.secondary-locale.description':
    'Switch to the primary locale to create and manage component variants.',
  'designer.components.style-variants.disabled.description':
    'Component variants cannot be modified.',
  'designer.components.style-variants.variant-name-already-exists':
    'This variant name already exists',
  'designer.components.style-variants.delete-variant.title': 'Delete variant?',
  'designer.components.style-variants.delete-variant.description':
    'All component instances with {{variantName}} selected will be set to the default variant.',
  'designer.components.style-variants.delete-variant.cancel-cta': 'Cancel',
  'designer.components.style-variants.delete-variant.delete-cta': 'Delete',
  'designer.components.style-variants.delete-variant.interactions-deleted':
    '{{count}} {{interactionPluralized}} scoped to {{variantName}} will also be deleted.',
  'designer.components.style-variants.delete-variant.interactions-modified':
    '{{count}} {{interactionPluralized}} scoped to {{variantName}} will be modified.',
  'designer.components.style-variants.base-variant.delete-disabled':
    "Base variant can't be deleted",
  'designer.components.style-variants.selected-variant.aria-label':
    'Variant: {{variant}}',
  'designer.components.ftu.properties-binding-dot.prefix': 'Click the',
  'designer.components.creation-validation-errors.nesting': `{{element}} are not allowed inside {{target}}.`,
  'designer.components.creation-validation-errors.nesting-component-creation': `{{target}} can’t be created inside a {{parent}} element.`,
  'designer.components.creation-validation-errors.nesting-generic': `This element contains elements that can’t be inside a {{target}}.`,
  'designer.components.creation-validation-errors.invalid-parent': `Elements inside {{parent}} can’t be turned into {{target}}.`,
  'designer.components.creation-validation-errors.already-component': `This element is already a {{target}}.`,
  'designer.components.creation-validation-errors.has-drop-target': `A Page Slot cannot be placed in a {{target}}.`,
  'designer.components.creation-validation-errors.element-not-supported': `This {{element}} element can’t be a {{target}}.`,
  'designer.components.creation-validation-errors.element-not-supported2': `The {{element}} element can’t be a {{target}}.`,
  'designer.components.creation-validation-errors.element-not-found': `This element can’t be a {{target}} because it can’t be found.`,
  'designer.components.creation-validation-errors.has-orphan-dyn-nodes': `{{target}} can’t contain dynamic elements that are not part of a Collection List Item.`,
  'designer.components.creation-validation-errors.conditional-visibility': `Elements using “current item” conditional visibility can’t be inside {{target}}.`,
  'designer.components.creation-validation-errors.has-dynamic-binding': `Elements with dynamic bindings can’t be turned into Components.`,
  'designer.components.creation-validation-errors.has-dynamo-wrapper-with-dyn-context-filter': `{{element}} with “current item” filters can’t be inside {{target}}.`,
  'designer.components.drag-drop-error': `Elements can’t be dragged into component instances outside of slots. Edit the component to add elements.`,
  'designer.components.optimization.drag-drop-error':
    'This element cannot be reordered in an optimization',
  'designer.components.optimization.drag-new-element-error':
    'Components can only be added to Page Slots that are already edited in this variation',
  'designer.components.sitewide-validation-failed':
    '{{element}} can not be placed inside this component',
  'designer.components.component-ancestor-validation-failed':
    'This element cannot be added to components used inside {{ancestor}} elements',
  'designer.components.component-contains-forbidden-elements':
    'This component cannot be added to rich text because it contains {{elementType}}',
  'designer.components.circular-component-reference':
    'This component cannot be added here because it would create a circular reference',
  'designer.components.cannot-add-component-to-rich-text-in-component-definition':
    'Components cannot be added to Rich Text inside a main component.',
  'designer.components.actions.export-devlink-tooltip': 'Export components',
  'designer.components.libraries.installing-library.title': 'Installing library',
  'designer.components.libraries.disable-cloning.title': 'Disable cloning?',
  'designer.components.libraries.disable-cloning.body':
    'Cloning is not supported for sites using a library. The site will continue to be showcased with cloning disabled.',
  'designer.components.libraries.disable-cloning.cancel': 'Cancel',
  'designer.components.libraries.disable-cloning.continue': 'Continue',
  'designer.components.libraries.apply-tag-styles.title':
    'Apply tag styles from {{displayName}}?',
  'designer.components.libraries.apply-tag-styles.body':
    'This site already has styles set on HTML tags. Tag styles from this library will apply where styles aren’t defined — your existing styles will take priority where they conflict. You can apply or remove tag styles anytime in the Style selectors panel.',
  'designer.components.libraries.apply-tag-styles.apply': 'Apply tag styles',
  'designer.components.libraries.apply-tag-styles.skip': 'Skip for now',
  'designer.components.libraries.apply-tag-styles.cancel': 'Cancel',
  'designer.components.libraries.apply-tag-styles.install': 'Install',
  'designer.components.libraries.recover-orphaned-content.title':
    'Orphaned library resources detected',
  'designer.components.libraries.recover-orphaned-content.body-singular':
    '1 component is disconnected from the installed library version and may not render correctly. Would you like to recover these automatically? A snapshot will be created before making any changes.',
  'designer.components.libraries.recover-orphaned-content.body-plural':
    '{{orphanedComponentsCount}} components are disconnected from the installed library version and may not render correctly. Would you like to recover these automatically? A snapshot will be created before making any changes.',
  'designer.components.libraries.recover-orphaned-content.cancel': 'Cancel',
  'designer.components.libraries.recover-orphaned-content.continue': 'Continue',
  'designer.components.libraries.share-updates': 'Share updates',
  'designer.components.libraries.share-with-workspace': 'Share with Workspace',
  'designer.components.libraries.transcoding-in-progress': `Cannot share library while processing assets`,
  'designer.components.libraries.share-library-with-workspace':
    'Share library with Workspace',
  'designer.components.libraries.library-cannot-be-shared.issue': 'Issue',
  'designer.components.libraries.install-to-workspace': 'Install',
  'designer.components.libraries.installed-to-workspace': 'Installed',
  'designer.components.libraries.are-you-sure-you-want-to-uninstall':
    'Are you sure you want to uninstall {{displayName}}? Library resources in use will be copied to your site and continue to work.',
  'designer.components.libraries.uninstall': 'Uninstall',
  'designer.components.libraries.uninstall-cancel': 'Cancel',
  'designer.components.libraries.layout-count.singular': '{{count}} layout',
  'designer.components.libraries.layout-count.plural': '{{count}} layouts',
  'designer.components.libraries.install-library': 'Install library',
  'designer.components.libraries.uninstall-library': 'Uninstall library',
  'designer.components.libraries.uninstall-library-title': 'Uninstall library?',
  'designer.components.libraries.review-changes': 'Review changes',
  'designer.components.libraries.view': 'View',
  'designer.components.libraries.review-updates': 'Review updates',
  'designer.components.libraries.review-available-updates':
    'Updates to {{displayName}} are available to review',
  'designer.components.libraries.review-multiple-available-updates':
    'Updates to multiple libraries are available to review',
  'designer.components.libraries.received-updates-from-multiple': 'Received updates from {{count}} libraries',
  'designer.components.libraries.open-library-source': 'Go to source site',
  'designer.components.libraries.detach-library-instance':
    'Convert to site component',
  'designer.components.libraries.restricted-from-sharing':
    "You don't have permission to share this library. Ask your Workspace admin for help.",
  'designer.components.libraries.restricted-from-reviewing':
    "You don't have permission to review library changes. Ask your Workspace admin for help.",
  'designer.components.libraries.validation.cannot-uninstall-active-page-branches':
    'You cannot uninstall libraries on this site while there are active page branches.',
  'designer.components.libraries.validation.cannot-install-site-is-shared':
    'Libraries cannot be installed on a library source site.',
  'designer.components.libraries.validation.components-cannot-have-circular-references':
    'Components cannot have circular references.',
  'designer.components.libraries.validation.cross-library-dependency-validation':
    'You cannot share a library from this site while another library is installed',
  'designer.components.libraries.validation.sharing-entitlement-met':
    "You’ve shared the maximum number of libraries on your Workspace plan. Upgrade to Enterprise or Agency.",
  'designer.components.libraries.validation.no-entitlement':
    'Upgrade your Workspace plan to share components, variables, and assets across multiple sites.',
  'designer.components.libraries.validation.no-entitlement-cta': 'See plans',
  'designer.components.libraries.validation.no-collection-or-modes-on-branches':
    "{{feature}}s can't be modified on a branch.",
  'designer.components.libraries.workspace-members-acknowledgement':
    'Workspace members who do not have access to this site will still be able to see and install this library on their sites.',
  'designer.components.libraries.done-action': 'Done',
  'designer.components.libraries.push-updates-description-ready-to-update-enterprise':
    "Select sites below to update them to the latest library version shared with this Workspace, or review changes on individual sites first.",
  'designer.components.libraries.push-updates-description-ready-to-update-standard':
    "All sites below are available to update to the latest library version shared with this Workspace.",
  'designer.components.libraries.push-updates-description-up-to-date':
    'All sites below are using the latest library version shared with this Workspace.',
  'designer.components.libraries.empty-state-title': `You don’t have access to sites with {{libraryName}} installed`,
  'designer.components.libraries.empty-state-description': 'This list includes only sites you have access to. To review or update your access, go to Workspace settings or contact a Workspace admin.',
  'designer.components.libraries.push-updates-button-update': 'Update',
  'designer.components.libraries.push-updates-button-update-all': 'Update all sites',
  'designer.components.libraries.push-updates-button-close': 'Close',
  'designer.components.libraries.push-updates-button-cancel': 'Cancel',
  'designer.components.libraries.push-updates-select-all': 'Select all',
  'designer.components.libraries.push-updates-unselect-all': 'Unselect all',
  'designer.components.libraries.push-updates-popover-update-all': 'Are you sure you want to update all sites to the latest library version?',
  'designer.components.libraries.push-updates-popover-update-one': 'Are you sure you want to update 1 site to the latest library version?',
  'designer.components.libraries.push-updates-popover-update-some': 'Are you sure you want to update {{selectedCount}} sites to the latest library version?',
  'designer.components.libraries.push-updates-selected': 'selected',
  'designer.components.libraries.push-updates-tab-ready-to-update':
    'Available to update ({{count}})',
  'designer.components.libraries.push-updates-tab-up-to-date':
    'Up to date ({{count}})',
  'designer.components.libraries.push-updates-installations-link-tooltip': 'View library installations and update sites',
  'designer.components.libraries.in-flight-tooltip': 'Library update in progress — almost there',
  'designer.components.libraries.updating': 'Updating...',
  'designer.components.libraries.updating-all-sites': 'Updating all sites...',
  'designer.components.libraries.updating-all-sites-description': 'All sites with {{libraryName}} installed are being updated to the latest library version.',
  'designer.components.libraries.updates-applied': 'New updates from {{displayName}}',
  'designer.components.libraries.received-updates-from': 'Received updates from {{displayName}}',
  'designer.components.libraries.received-updates-on': 'On {{date}} at {{time}} by {{installer}}',
  'designer.components.libraries.manage-all-libraries': 'Manage all libraries',
  'designer.components.libraries.all-libraries-installed': 'No libraries are available to install.',
  'designer.components.libraries.learn-more':
    'Learn about libraries',
  'designer.components.libraries.explore-marketplace':
    'Explore the Marketplace',
  'designer.components.libraries.submit-to-marketplace':
    'Submit to Marketplace',
  'designer.components.libraries.library-with-name-no-longer-available':
    'Library {{displayName}} is no longer available',
  'designer.components.libraries.library-no-longer-available':
    'Library is no longer available',
  'designer.components.libraries.share-or-install': 'Share or install a library',
  'designer.components.libraries.ai-site-gen': "Libraries from AI-generated sites can't be exported just yet.",
  'designer.components.libraries.nothing-to-share': 'No resources to share.',
  'designer.components.libraries.library-empty-state':
    'Share components, variables, and assets across your Workspace, or use layouts from the Marketplace.',
  'designer.components.libraries.share': 'Share',
  'designer.components.libraries.update-to': 'update to',
  'designer.components.libraries.workspace': 'Workspace',
  'designer.components.libraries.share-with-all': 'with everyone in',
  'designer.components.libraries.reshare-library': 'Re-share library',
  'designer.components.libraries.reshare': 'Reshare',
  'designer.components.libraries.share-library': 'Share Library',
  'designer.components.libraries.share-library-lower': 'Share library',
  'designer.components.libraries.share-library-updates-title': 'Share {{displayName}} updates',
  'designer.components.libraries.share-library-updates-text': 'Share the latest library changes with this Workspace.',
  'designer.components.libraries.share-cancel': 'Cancel',
  'designer.components.libraries.share.error.title': 'Unable to pull updates',
  'designer.components.libraries.share.error.max-num-assets-reached':
    'Libraries can share up to 2,000 assets. Use “Asset settings” to manage which assets to share.',
  'designer.components.libraries.share.error.message':
    'There was an issue updating the changes to your library. Please try again.',
  'designer.components.libraries.share.error.try-again-button': 'Try again',
  'designer.components.libraries.unshare-cancel': 'Cancel',
  'designer.components.libraries.unshare-library': 'Unshare',
  'designer.components.libraries.unshare-library-with-workspace':
    'Unshare library?',
  'designer.components.libraries.unshare-will-not-available':
    'The library will no longer be available to install on sites in this Workspace.',
  'designer.components.libraries.unshare-sites-already-installed':
    'Sites that have already installed the library will not be affected.',
  'designer.components.libraries.review-library': 'Review changes',
  'designer.components.libraries.review-updates-to': 'Update to',
  'designer.components.libraries.review-used': 'Changes affecting your site',
  'designer.components.libraries.review-other': 'Other changes in this library',
  'designer.components.libraries.review-accept': 'Accept all updates',
  'designer.components.libraries.adobe-typekit-already-installed':
    "This site already has an Adobe Fonts project installed. Library fonts from Adobe Fonts won't be added.",
  'designer.components.libraries.component-disabled-when-has-permission':
    'You need design control to add components from libraries to the site',
  'designer.components.libraries.component-disabled-when-does-not-have-permission':
    'Components from libraries must first be added to the site by someone with permission',
  'designer.components.libraries.local-dev-cannot-be-placed':
    'This component only exists on your local dev server. Import the updated library to place it.',
  'designer.components.libraries.asset-settings': 'Asset settings',
  'designer.components.libraries.asset-settings.select-assets':
    'Select assets and folders to share',
  'designer.components.libraries.asset-settings.unorganized-assets':
    'Unorganized assets',
  'designer.components.libraries.asset-settings.assets-in-this-folder':
    'Assets in this folder',
  'designer.components.libraries.asset-settings.update-settings':
    'Update settings',
  'designer.components.libraries.asset-settings.cancel': 'Cancel',
  'designer.components.libraries.asset-settings.all-assets': 'All assets',
  'designer.components.libraries.asset-settings.no-folder': 'No folder',
  'designer.components.libraries.no-resources-to-share': 'No {{resources}} are available to share',
  'designer.components.libraries.no-layouts-to-share': 'No layouts created',
  'designer.components.libraries.cannot-share-with-library-installed': 'Site resources cannot be shared while libraries are installed',
  'designer.components.libraries.cannot-install-on-source-site': 'Shared libraries cannot be installed on a library source site.',
  'designer.components.libraries.learn-more-link': 'Learn more',
  'designer.components.branching.modal-data':
    'If you make changes to the content of this page, they will be lost when the branch is merged. However, global changes like components, classes, and interactions will be saved.',
  'designer.components.branching.with-variables-modal-data':
    'If you make changes to the content of this page, they will be lost when the branch is merged. However, global changes like components, classes, interactions and variables will be saved.',
  'designer.components.branching.detailed-modal-data':
    '{{name}} just created a branch for this page. If you make changes to the content of this page, they will be lost when the branch is merged. However, global changes like components, classes, and interactions will be saved.',
  'designer.element-move-error':
    'Elements cannot be moved outside of the Body.',
  'designer.element-slot-deletion':
    'This slot will be permanently deleted from every instance of this component, along with its contents and any conditions that use it.',
  'designer.components.libraries.libraries-available':
    'Libraries available to install',
  'designer.components.site-component-label': 'Site Components',
  'designer.components.no-properties': 'No properties',
  'designer.components.library-read-only':
    'Library components can only be edited on the source site',
  'designer.components.settings.read-only':
    'Edit the component on the source site to create or manage properties',
  'designer.components.disabled-in-slot-instance':
    'Go to an instance not in a slot to make changes.',
  'designer.components.disabled-in-slot':
    'Component can’t be edited inside a slot from the same component',
  'designer.components.component-canvas-disabled-in-page-branch':
    'Component editing is not available in page branches',
  'designer.components.code-component-disabled-in-page-branch':
    "Code components are global to the project and can't be edited on a branch. Switch to the main branch to make changes.",
  'designer.components.component-canvas.open-component': 'Open component',
  'designer.components.no-edit-permission':
    'You do not have permission to edit this element',
  'designer.components.disabled-stale-component':
    'Changes have been made to this component. Refresh the site to access the latest version.',
  'designer.components.libraries.review-conflict': 'Potential conflict',
  'designer.components.libraries.review-added': 'Added',
  'designer.components.libraries.review-removed': 'Removed',
  'designer.components.libraries.review-changed': 'Changed',
  'designer.components.libraries.asset': 'asset',
  'designer.components.libraries.component': 'component',
  'designer.components.libraries.variable': 'variable',
  'designer.components.libraries.font': 'font',
  'designer.components.libraries.instruction': 'instruction',
  'designer.components.libraries.instructions': 'Instructions',
  'designer.components.libraries.skill': 'skill',
  'designer.components.libraries.rule': 'rule',
  'designer.components.libraries.view-instructions': 'View instructions',
  'designer.components.libraries.tag-style': 'tag style',
  'designer.components.libraries.layout': 'layout',
  'designer.components.libraries.site': 'site',
  'designer.components.libraries.no-changes-to-share':
    'No new changes to share',
  'designer.components.libraries.no-resources-were-changed':
    'No design resources used on this site were changed',
  'designer.components.libraries.push-updates-sent-to-all-sites': 'Sent library updates to all sites',
  'designer.components.libraries.push-updates-sent-to-sites': 'Sent library updates to {{count}} {{site}}',
  'designer.components.libraries.review-removed-tooltip':
    'This component has been removed from the library. A site component will be created for existing instances.',
  'designer.components.libraries.review-conflict-tooltip':
    'Component properties have changed and existing overrides may be lost.',
  'designer.components.libraries.describe-publish':
    'Describe what you’re sharing (optional)',
  'designer.components.libraries.describe-publish-updates':
    'Describe the updates (optional)',
  'designer.components.libraries.describe-publish-updates-placeholder':
    'e.g., Updated components and assets',
  'designer.components.libraries.describe-publish-updates-label':
    'Describe library updates',
  'designer.components.libraries.review-conflict-select-accept-option':
    'Accept update',
  'designer.components.libraries.review-conflict-select-convert-option':
    'Convert to site component',
  'designer.components.libraries.review-conflict-select-convert-option-note':
    'A site component will be created to keep existing instances unchanged',
  'designer.components.libraries.review-conflict-select-accept-option-note':
    'Existing instances will be updated to match the new design',
  'designer.components.libraries.review-conflict-select-aria-label':
    'Select an option to resolve possible conflict',
  'designer.components.libraries.review-updates-available': 'Updates available',
  'designer.components.libraries.up-to-date': 'Up to date',
  'designer.components.libraries.sites': 'Sites',
  'designer.components.libraries.summary.component': 'component',
  'designer.components.libraries.summary.code-component': 'code component',
  'designer.components.libraries.summary.variable': 'variable',
  'designer.components.libraries.summary.tag-style': 'tag style',
  'designer.components.libraries.summary.font': 'font',
  'designer.components.libraries.summary.skill': 'skill',
  'designer.components.libraries.summary.rule': 'rule',
  'designer.components.libraries.summary.image': 'image',
  'designer.components.libraries.summary.audio': 'audio',
  'designer.components.libraries.summary.document': 'document',
  'designer.components.libraries.summary.lottie-asset': 'Lottie asset',
  'designer.components.libraries.summary.rive-asset': 'Rive asset',
  'designer.components.libraries.unsupported-components':
    'Unsupported components',
  'designer.components.libraries.updates': 'Updates',
  'designer.components.libraries.update': 'Update',
  'designer.components.libraries.shared': 'Shared',
  'designer.components.libraries.shared-resources': 'Shared resources',
  'designer.components.libraries.shared-resources-libraries-now-include-assets':
    'Libraries now include assets from the source site',
  'designer.components.libraries.shared-resources-libraries-now-include-background-video':
    'Background Video elements are now supported',
  'designer.components.libraries.shared-resources-libraries-now-include-site-search':
    'Search elements are now supported',
  'designer.components.libraries.local': 'Local',
  'designer.components.libraries.local-development':
    'Served from your machine for local development. Only you can see it.',
  'designer.components.libraries.local-dev.overridden-tooltip':
    'Overridden by a local dev server',
  'designer.components.libraries.local-dev.offline': 'Offline',
  'designer.components.libraries.local-dev.offline-different-library':
    'Your local dev server is serving a different library. Installed components are shown instead.',
  'designer.components.libraries.local-dev.offline-unreachable':
    "Can't reach your local dev server. Installed components are shown until it's back.",
  'designer.components.libraries.local-dev.override-switch':
    'Use local override',
  'designer.components.libraries.local-dev.opt-in-note.title':
    'Enable local code components',
  'designer.components.libraries.local-dev.opt-in-note.body':
    'Detects a local dev server on the port set in site settings. Your browser may ask for local network access.',
  'designer.components.libraries.local-dev.opt-in-note.action': 'Enable',
  'designer.components.libraries.local-dev.opt-in-note.decline':
    "Don't enable",
  'designer.components.libraries.local-dev.toast.connected-library':
    'Connected to "{{libraryName}}" at {{origin}}',
  'designer.components.libraries.local-dev.toast.enabled':
    'Local code components are enabled. You can disable them in site settings.',
  'designer.components.libraries.local-dev.toast.enabled-cta': 'Open settings',
  'designer.components.libraries.local-dev.toast.lost-library':
    'Lost connection to "{{libraryName}}" at {{origin}}',
  'designer.components.libraries.local-dev.toast.not-installed':
    'Detected "{{libraryName}}", but it isn\'t installed on this site.',
  'designer.components.libraries.local-dev.toast.not-installed-cta':
    'Open Libraries',
  'designer.components.libraries.unshared': 'Unshared',
  'designer.components.libraries.unshare': 'Unshare Library',
  'designer.components.libraries.unshare-lower': 'Unshare library',
  'designer.components.libraries.unshared-if-uninstall':
    'This library is no longer shared with your Workspace. Uninstall to copy components, variables, and assets in use to your site.',
  'designer.components.libraries.cannot-edit-library-fonts':
    'Fonts from a Library can only be edited from the source site',
  'designer.components.libraries.cannot-delete-library-fonts':
    'Fonts from a Library can only be deleted from the source site',
  'designer.components.cms.context.creation.title':
    'Some settings will be disconnected',
  'designer.components.cms.context.creation.description':
    'Props will be created automatically for settings connected to the CMS. The following types are not supported and will be disconnected.',
  'designer.components.variables.roles.no-permission.modify-collection':
    "Your role doesn't have permission to modify collections",
  'designer.components.variables.roles.no-permission.create-modes':
    "Your role doesn't have permission to create modes",
  'designer.components.settings.properties.clean-up-unused.title':
    'Delete unused properties?',
  'designer.components.settings.properties.clean-up-unused.description':
    "Delete {{count}} unused {{propPluralized}}?",
  'designer.components.settings.properties.clean-up-unused.delete-cta':
    'Delete',
  'designer.components.settings.properties.clean-up-unused.cancel-cta':
    'Cancel',
  'designer.components.global-component-settings.panel.empty-state.title': 'No global style components',
  'designer.components.global-component-settings.panel.empty-state.description': 'Add components with custom styles to include on the component canvas and previews.',
  'designer.components.global-component-settings.panel.input.placeholder': 'Search components',
  'designer.components.global-component-settings.panel.no-match': 'No matching components',
  'designer.components.global-component-settings.panel.all-added': 'All components have been added',
  'designer.components.global-component-settings.panel.active.title': 'Active global style components',
  'designer.components.global-component-settings.panel.add': 'Add',
  'designer.components.global-component-settings.panel.remove': 'Remove',
  'designer.components.global-component-settings.panel.save': 'Apply',
  'designer.components.global-component-settings.panel.cancel': 'Cancel',
  'designer.components.add-menu.disabled-tooltip-rt-in-component':
    'Components cannot be added to Rich Text inside this component.',
  'designer.components.add-menu.disabled-tooltip-rt-property':
    'Components cannot be added inside Rich Text properties.',
  'designer.components.add-menu.disabled-tooltip-rt-branch':
    'Components cannot be added to Rich Text on a branch.',
  'designer.components.add-menu.disabled-tooltip-rt-locale':
    'Components cannot be added to Rich Text on a secondary locale.',
  'designer.components.slot-restriction-error':
    '{{componentName}} cannot be used in this slot.',
  'designer.components.slot-restriction-error.cta': 'See allowed components',
  'designer.components.manager.slot-restriction-note.body':
    'This slot is restricted to these components.',
  'designer.components.manager.slot-restriction-note.learn-more':
    'Learn more about component slot restrictions',
  'designer.components.libraries.local-dev.detection-note.title':
    'Enable local code components',
  'designer.components.libraries.local-dev.detection-note.body':
    'Detects running local dev servers and shows your local versions of matching code components. Your browser may ask for access to your local network.',
  'designer.components.libraries.local-dev.detection-switch':
    'Enable local dev server detection',
  'designer.components.libraries.local-dev.port-note.title':
    'Local dev server settings',
  // `{{command}}` and `{{flag}}` are set in code font by the panel, wherever they
  // sit in the sentence.
  'designer.components.libraries.local-dev.port-note.body':
    'Match this to the port that {{command}} runs on. The CLI uses {{defaultPort}} unless you pass {{flag}}.',
  'designer.components.libraries.local-dev.port-label': 'Port',
} as const;
